import { createContext, useCallback, useContext, useState } from 'react';
import type { ReactNode } from 'react';
import { DeskingExitErrorsModal } from './components/DeskingExitErrorsModal';
import { DeskingSaveErrorsModal } from './components/DeskingSaveErrorsModal';

interface ValidationGuardContextValue {
    openExitModal: () => void;
    openSaveModal: () => void;
}

export const ValidationGuardContext = createContext<ValidationGuardContextValue>({
    openExitModal: () => undefined,
    openSaveModal: () => undefined
});

export const useValidationGuardContext = () => useContext(ValidationGuardContext);

export const ValidationGuardProvider = ({ children }: { children: ReactNode }) => {
    const [showExitModal, setShowExitModal] = useState(false);
    const [showSaveModal, setShowSaveModal] = useState(false);

    const openExitModal = useCallback(() => setShowExitModal(true), []);
    const openSaveModal = useCallback(() => setShowSaveModal(true), []);

    return (
        <ValidationGuardContext.Provider value={{ openExitModal, openSaveModal }}>
            {children}
            <DeskingExitErrorsModal show={showExitModal} onClose={() => setShowExitModal(false)} />
            <DeskingSaveErrorsModal show={showSaveModal} onClose={() => setShowSaveModal(false)} />
        </ValidationGuardContext.Provider>
    );
};
